

let router = [
    {
        path: 'platform',
        component: (resolve => {
            require(["../function/page_group/main_box.vue"], resolve)
        }),
        redirect: '/IBMS/platform/createNewProject',
        children: [


            //新建项目
            {
                path: 'createNewProject',
                component: (resolve => {
                    require(["./createNewProject.vue"], resolve)
                })
            },
        ]
    },
   ]
export default router